import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { MenuItem, IconMenu, IconButton } from 'material-ui';
import { toLaxTitleCase } from 'titlecase';
import { updateUMProps, deleteUser } from '../../../stores/settings/userManagement/actions';
import { availableAccess } from './teamPermissionOptions';
import { resendConfirmationLink as resendConfirm } from '../../../stores/settings/settings-actions';
import { getAccessIcons, getCreateLocIcon } from '../accessIcons';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

class MultiLoc extends Component {

  constructor() {
    super();
    this.state = {
      addNewUserDialog: false,
      editUserDialog: false,
      sortBy: '', // name or email
      sortDirection: 'forward', // forward (a to z) or backward (z to a)
      sortedMembers: null,
      expandedRows: [],
    };
  }

  render() {
    const { settings, corporateAccess, locAccess, userManagementReducer, updateProp, removeUser, userId, resendConfirmationLink, isAccom } = this.props;
    const { sortDirection, sortBy, sortedMembers, expandedRows } = this.state;
    const usersArray = R.propOr([], 'usersArray', userManagementReducer);
    const addUserMessage = settings.get('addUserMessage');
    const manageUsersMessage = settings.get('manageUsersMessage') ? <p style={{ color: 'green' }}>{settings.get('manageUsersMessage')}</p> : undefined;
    const sortAZZA = (field, membersToSort) => (<IconButton
      iconClassName={R.equals(field, sortBy) ? R.equals(sortDirection, 'forward') ? 'tc-icon-move-down' : 'tc-icon-move-up' : 'tc-icon-move-down'}
      iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', marginTop: '5px' }}
      tooltip={R.equals(sortDirection, 'forward') ? 'A-Z' : 'Z-A'}
      onTouchTap={() => {
        const fieldName = field === 'email' ? 'email' : 'first_name';
        const sorted = R.equals(sortDirection, 'forward') ?
          membersToSort.sort((a, b) => (a[fieldName] > b[fieldName]) ? 1 : ((b[fieldName] > a[fieldName]) ? -1 : 0)) :
          membersToSort.sort((a, b) => (a[fieldName] < b[fieldName]) ? 1 : ((b[fieldName] < a[fieldName]) ? -1 : 0));
        this.setState({
          sortBy: field,
          sortDirection: R.equals(sortDirection, 'forward') ? 'backward' : 'forward',
          sortedMembers: sorted,
        });
      }}
    />);
    const users = sortedMembers ? sortedMembers : usersArray;

    return (
      <div>
        {this.props.settings.get('addUserMessage').hasOwnProperty('emailExists') && addUserMessage.emailExists === false && addUserMessage.message &&
        <p style={{ color: 'green' }}>{addUserMessage.message}</p>
        }
        {manageUsersMessage}
        <div>
          <div style={{ padding: '0 1%', display: 'flex', flexDirection: 'row', borderBottom: isNilOrEmpty(expandedRows) ? '1px solid #e0e0e0' : '', width: '100%', color: 'rgb(158, 158, 158)', fontSize: '12px' }}>
            <div style={{ display: 'flex', width: '24%', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>Name {sortAZZA('name', this.props.settings.get('usersArray'))}</div>
            </div>
            <div style={{ display: 'flex', width: '24%', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>Email {sortAZZA('email', this.props.settings.get('usersArray'))}</div>
            </div>
            <div style={{ display: 'flex', width: '24%', justifyContent: 'center', alignItems: 'center' }}>Status</div>
            <div style={{ display: 'flex', width: '9%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
              <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', display: 'flex', alignContent: 'flex-start', justifyContent: 'flex-start' }}>
                # of {isAccom ? 'Properties' : 'Locations'}
              </div>
            </div>
            <div style={{ display: 'flex', width: '9%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
              <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', display: 'flex', alignContent: 'flex-start', justifyContent: 'flex-start' }}>Corporate Profile</div>
            </div>
            <div style={{ display: 'flex', width: '10%' }} />
          </div>
          <div>
            {
              users.map((user, index) => {
                const status = (() => {
                  if (user.status === 'pending') return 'Pending for Approval';
                  if (user.status === 'approved') {
                    if (user.confirmed_at) return 'Email Confirmed';
                    return 'Email Not Confirmed';
                  }
                  if (user.status === 'rejected') return 'Rejected';
                })();
                const userAccess = feature => R.prop(0, R.pluck('value')(availableAccess.filter(obj => R.equals(obj.value, user[feature]))));
                const findUser = usersArray.filter(obj => obj._id === user._id);
                const expanded = R.contains(index, this.state.expandedRows);
                return (
                  <div key={index} style={{ border: expanded ? '2px solid #e0e0e0' : '', padding: '0 1%' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', borderBottom: expanded ? '' : '1px solid #e0e0e0' }}>
                      <div style={{ display: 'flex', width: '24%', overflow: 'hidden' }}>
                        <span style={{ maxWidth: '250px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{user.first_name || user.last_name ? toLaxTitleCase(`${user.first_name} ${user.last_name}`) : ''}</span>
                      </div>
                      <div style={{ display: 'flex', width: '24%', overflow: 'hidden' }}>
                        <span style={{ maxWidth: '250px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{user.email}</span>
                      </div>
                      <div style={{ display: 'flex', width: '24%', justifyContent: 'center' }}>{status}</div>
                      <div style={{ display: 'flex', width: '9%', justifyContent: 'center' }}>{R.pathOr(0, [0, 'locAccess', 'length'], findUser)}</div>
                      <div style={{ display: 'flex', width: '9%', justifyContent: 'center' }}>{getCreateLocIcon(user.profile || [])}</div>
                      <div style={{ display: 'flex', width: '10%', padding: 0, textAlign: 'right' }}>
                        {R.isEmpty(R.pathOr([], [0, 'locAccess'], findUser)) && R.contains('write', corporateAccess) ?
                          <IconMenu iconButtonElement={<IconButton iconClassName="tc-icon-more-vert" iconStyle={{ padding: 0 }} />}>
                            <MenuItem primaryText="Edit" onTouchTap={() => {
                              if (R.contains('write', R.pathOr([], [0, 'admin'], locAccess))) {
                                const obj = R.merge(R.propOr({}, 0, findUser), {
                                  locs: [],
                                  teams: [],
                                  admin: [],
                                  firstName: R.propOr('', 'first_name', user),
                                  lastName: R.propOr('', 'last_name', user),
                                  userId: user._id,
                                });
                                const processedUser = {
                                  firstName: R.propOr('', 'first_name', user),
                                  lastName: R.propOr('', 'last_name', user),
                                  userId: user._id,
                                  ...user,
                                };
                                updateProp({
                                  editUserDialog: true,
                                  editedUser: R.merge(processedUser, { allLocsSelected: false }),
                                  originalUser: processedUser });
                                if (sortedMembers) this.setState({ sortedMembers: null, sortBy: '', sortDirection: 'forward' });
                              } else {
                                this.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'userAccess' } });
                              }
                            }}
                            />
                            {user.status.toLowerCase() === 'approved' && !user.confirmed_at &&
                            <MenuItem primaryText="Resend Confirmation Link" onTouchTap={() => resendConfirmationLink(user.email)} />}
                            {R.contains('write', corporateAccess) && (userId !== user._id) &&
                            <MenuItem primaryText="Delete User" onTouchTap={() => removeUser(user._id)} />}
                          </IconMenu> :
                          <IconButton iconClassName={expanded ? 'tc-icon-expand_less' : 'tc-icon-expand_more'} iconStyle={{ padding: 0 }} onTouchTap={() => this.setState({ expandedRows: expanded ? R.without([index], this.state.expandedRows) : R.append(index, this.state.expandedRows) })}/>
                        }
                      </div>
                    </div>
                    {
                      expanded &&
                      <div style={{ padding: '1% 4%' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', borderBottom: '1px solid #e0e0e0', width: '100%', color: 'rgb(158, 158, 158)', fontSize: '12px' }}>
                          <div style={{ display: 'flex', width: '35%', justifyContent: 'center', alignItems: 'center' }}>{isAccom ? 'Property' : 'Location'} Name</div>
                          <div style={{ display: 'flex', width: '25%', justifyContent: 'center', alignItems: 'center' }}>Team(s)</div>
                          <div style={{ display: 'flex', width: '10%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>Profile</div>
                          <div style={{ display: 'flex', width: '10%', justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginRight: '4%' }}>
                            <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                              User Management
                            </div>
                          </div>
                          <div style={{ display: 'flex', width: '10%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>Contracting</div>
                          <div style={{ display: 'flex', width: '10%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}/>
                        </div>
                        <div>
                          {
                            R.pathOr([], [0, 'locAccess'], findUser).map((loc, i) => {
                              const locationAccess = (feature) => loc[feature];
                              return (
                                <div key={i} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', borderBottom: expanded ? '' : '1px solid #e0e0e0' }}>
                                  <div style={{ display: 'flex', width: '35%', overflow: 'hidden' }}>
                                    <span style={{ maxWidth: '250px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{toLaxTitleCase(loc.property_name)}</span>
                                  </div>
                                  <div style={{ display: 'flex', width: '25%', justifyContent: 'center' }}>{loc.teams.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0)).join(', ')}</div>
                                  <div style={{ display: 'flex', width: '10%', justifyContent: 'center' }}>{getAccessIcons(locationAccess('profile'))}</div>
                                  <div style={{ display: 'flex', width: '10%', justifyContent: 'center', marginRight: '4%' }}>{getAccessIcons(locationAccess('admin'))}</div>
                                  <div style={{ display: 'flex', width: '10%', justifyContent: 'center' }}>{getAccessIcons(locationAccess('contracting'))}</div>
                                  <div style={{ display: 'flex', width: '10%', padding: 0, textAlign: 'right' }}>
                                    <IconMenu iconButtonElement={<IconButton iconClassName="tc-icon-more-vert" iconStyle={{ padding: 0 }} />}>
                                      <MenuItem primaryText="Edit" onTouchTap={() => {
                                        // only allow user to modify permission that they themselves have
                                        // User Management access too
                                        const processedLocAccess = user.locAccess.map(obj => {
                                          if (locAccess
                                            .some(access => access.locId === obj.locId
                                              && access.admin.indexOf('write') > -1)) {
                                            return { ...obj, disabled: false };
                                          }
                                          return { ...obj, disabled: true };
                                        });
                                        if (processedLocAccess.some(obj => !obj.disabled)) {
                                          const processedUser = {
                                            ...user,
                                            firstName: R.propOr('', 'first_name', user),
                                            lastName: R.propOr('', 'last_name', user),
                                            userId: user._id,
                                            locAccess: processedLocAccess,
                                          };
                                          updateProp({
                                            editUserDialog: true,
                                            editedUser: R.merge(processedUser, { allLocsSelected: false }),
                                            originalUser: processedUser });
                                          if (sortedMembers) this.setState({ sortedMembers: null, sortBy: '', sortDirection: 'forward' });
                                        } else {
                                          this.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'userAccess' } });
                                        }
                                      }}
                                      />
                                      {user.status.toLowerCase() === 'approved' && !user.confirmed_at &&
                                      <MenuItem primaryText="Resend Confirmation Link" onTouchTap={() => resendConfirmationLink(user.email)} />}
                                      {R.contains('write', corporateAccess) && (userId !== user._id) &&
                                      <MenuItem primaryText="Delete User" onTouchTap={() => removeUser(user._id)} />}
                                    </IconMenu>
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                      </div>
                    }
                  </div>
                );
              })
            }
          </div>
        </div>
        <br />
      </div>
    );
  }
}

MultiLoc.propTypes = {
  settings: PropTypes.object,
  corporateAccess: PropTypes.array,
  locAccess: PropTypes.array,
  updateProp: PropTypes.func,
  userManagementReducer: PropTypes.object,
  resendConfirmationLink: PropTypes.func,
  userId: PropTypes.string,
  removeUser: PropTypes.func,
  triggerNoAccessWarning: PropTypes.func,
  isAccom: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  triggerNoAccessWarning: payload => dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload }),
  updateProp: (...args) => dispatch(updateUMProps(...args)),
  resendConfirmationLink: (email) => dispatch(resendConfirm(email)),
  removeUser: (...args) => dispatch(deleteUser(...args)),
});

const mapStateToProps = ({ settings, user, userManagement }) => ({
  settings,
  corporateAccess: user.get('corporateAccess'),
  locAccess: user.get('locAccess'),
  userManagementReducer: userManagement.toJS(),
  userId: user.get('id'),
  isAccom: user.getIn(['company', 'productType']) === 'Accommodation',
});

export default connect(mapStateToProps, mapDispatchToProps)(MultiLoc);



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/multiLoc.jsx